import React from 'react';
import { Placeholder } from 'semantic-ui-react';

const Loading = () => (
  <Placeholder>
    <Placeholder.Line />
  </Placeholder>
);
export default Loading;
